import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="bg-white rounded-lg shadow-2xl max-w-2xl mx-4 p-8 relative animate-in zoom-in-95 duration-300">
        <button
          onClick={handleDecline}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Kişisel verilerinize saygı gösteririz ve koruruz
        </h2>

        <div className="space-y-4 text-gray-600 mb-6">
          <p>
            İş ortaklarımıza birlikte, internet sitemizi kullanımınız hakkında bilgi toplamak ve saklamak
            için çerezler ve dahil olmak üzere çeşitli teknolojiler kullanırız.
          </p>
          <p>
            'Tümünü Kabul Et'i tıklayarak, bilgilerinizin İçerik, pazarlama ve raporlama amaçlarıyla
            kullanılmasına izin vermiş olursunuz. Onayınızı, sayfanın sol alt köşesindeki yeşil simgeye
            basarak istediğiniz zaman geri çekebilirsiniz.
          </p>
          <p>
            'Detayları göster'i tıklayarak kişisel verilerin toplanması ve işlenmesinin yanı sıra
            çerezleri ve diğer teknolojileri kullanımımız hakkında daha fazla bilgi edinebilirsiniz.
          </p>
        </div>

        <div className="space-y-3">
          <a href="#" className="text-sky-500 hover:text-sky-600 font-medium block">
            Çerezler hakkında
          </a>
          <a href="#" className="text-sky-500 hover:text-sky-600 font-medium block">
            Google gizlilik politikası
          </a>
          <a href="#" className="text-sky-500 hover:text-sky-600 font-medium block">
            Ayrıntıları göster
          </a>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mt-6">
          <Button
            onClick={handleAccept}
            className="flex-1 bg-sky-500 hover:bg-sky-600 text-white"
          >
            Tümünü kabul et
          </Button>
          <Button
            onClick={handleDecline}
            variant="outline"
            className="flex-1 border-sky-500 text-sky-500 hover:bg-sky-50"
          >
            Yalnızca gerekli çerezler
          </Button>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-200 text-xs text-gray-500">
          Powered by Cookie Information
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
